import { Map, List } from 'immutable';
import createSelector from '../../utils/reselect';

const getSite = (state: any) => {
    const { site } = state;
    return site || Map();
};

export const getAuthenticationConfiguration = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'authentication']);
});

export const getNotification = createSelector(getSite, (state) => {
    return state.getIn(['site', 'notification']) || Map();
});

export const getSiteFeaturesList = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'features']) || List();
});

export const getSiteTitle = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'title']) || 'MyLicense';
});

export const getAddPersonFormId = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'contact', 'addFormId']) || '';
});

export const getCalendarSearchFormId = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'calendar', 'searchFormId']);
});

export const getTimeSheetSearchFormId = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'timeAndExpense', 'searchFormId']);
});

export const getCitationSearchFormId = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'citation', 'searchFormId']);
});

export const getInboxSearchFormId = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'inbox', 'searchFormId']);
});

export const getLicenseTableColumns = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'licensing', 'fields']);
});

export const getCalendarColumnFields = createSelector(getSite, (state) => {
    return state.getIn(['site', 'data', 'calendar']) || [];
});
